import React from 'react';
import { Helmet } from 'react-helmet';
import SocialMediaMarketing from './SocialMediaMarketing';

const SocialMediaMarketingPage = () => (
  <>
    <Helmet>
      <title>Social Media Marketing | MilaajBrandset</title>
      <meta
        name="description"
        content="Enhance your social media presence with MilaajBrandset's social media marketing services. Drive engagement and growth across platforms."
      />
      <meta
        name="keywords"
        content="MilaajBrandset, social media marketing, social media strategy, engagement, growth"
      />
      <meta property="og:title" content="Social Media Marketing | MilaajBrandset" />
      <meta
        property="og:description"
        content="Enhance your social media presence with MilaajBrandset's social media marketing services. Drive engagement and growth across platforms."
      />
    </Helmet>
    <SocialMediaMarketing />
  </>
);

export default SocialMediaMarketingPage;